import { setAutoUpdate } from "../../modules/feedManager/store";
import {
  getAutoUpdateFromMemoryTable,
  getDataFromMemoryTable,
  getStagingStateFromMemoryTable,
} from "../../service/sourceServices";
import { setSecuritiesValuesState, setStagingState } from "../../service/store";

export const loadAutoUpdateStatus = (dispatch: any) => {
  Excel.run(async (context) => {
    const autoUpdateStatus = await getAutoUpdateFromMemoryTable(context);
    dispatch(setAutoUpdate(autoUpdateStatus));

    await context.sync();
  });
};

export const loadSentValues = async (dispatch: any) => {
  Excel.run(async (context) => {
    const sentValues = await getDataFromMemoryTable(context);
    dispatch(setSecuritiesValuesState(sentValues));

    await context.sync();
  });
};

export const loadStagingState = async (dispatch: any) => {
  Excel.run(async (context) => {
    const stagingState = await getStagingStateFromMemoryTable(context);
    dispatch(setStagingState(JSON.parse(stagingState)));

    await context.sync();
  });
};
